export default "__VITE_ASSET__CrRDAl5f__"